import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Hauptgast", -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Anschrift", -1)
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Unterschrift", -1)

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonInput,
  IonItem,
  IonList,
  IonLabel,
  IonRow,
  IonCol,
  IonCard,
  IonCardTitle,
  IonCardHeader,
  IonCardContent,
  IonLoading,
  IonListHeader,
  loadingController,
} from "@ionic/vue";
import { VueSignaturePad } from "vue-signature-pad";
import { app, auth, db } from "@/firebase-service";
import { set, ref as storageRef } from "@firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";
import { computed, nextTick, onMounted, reactive, ref } from "vue";
import { settings } from "ionicons/icons";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import { SwiperComponent } from "swiper/angular";
import { useRouter } from "vue-router";
import { useAuth } from "@vueuse/firebase/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const { user } = useAuth(auth);

const router = useRouter();
const firstname = ref("");
const surname = ref("");
let mySwiper = null;
let loading: any;

onMounted(async () => {
  loading = await loadingController.create({});
});

const signaturePad = ref(null);

const signed = ref(false);

const initCheckInData = {
  plz: "",
  city: "",
  street: "",
  country: "",
  guests: [
    {
      firstname: "",
      surname: "",
      title: "",
      nationality: "",
      birthday: "",
    },
  ],
};

const checkInData = ref(JSON.parse(JSON.stringify(initCheckInData)));
const functions = getFunctions(app);

setTimeout(() => {
  signaturePad.value.resizeCanvas();
}, 100);

function reset() {
  mySwiper.enable();
  mySwiper.slideTo(0);
  mySwiper.disable();
  resetSignature();
  checkInData.value = JSON.parse(JSON.stringify(initCheckInData));
}

function onEnd() {
  console.log("end");
  signed.value = true;
}

function resetSignature() {
  signaturePad.value.clearSignature();
  signed.value = false;
}

function addGuest() {
  checkInData.value.guests.push({ firstname: "", surname: "" });
}

function removeGuest(number: number) {
  checkInData.value.guests.splice(number, 1);
}

async function sendMail() {
  await loading.present();
  let mail: string | null = "stefan.schaefer998@gmail.com";
  if (user.value) {
    mail = user.value.email;
  }
  const addMessage = httpsCallable(functions, "sendCheckInMail");
  const result = await addMessage({
    firstname: firstname.value,
    surname: surname.value,
    email: mail,
    body: buildMailBody(),
  });
  const data = result.data;
  console.log(data);
  await loading.dismiss();
  reset();
}

function buildMailBody() {
  let str = "";
  str += "<h1>Check In Daten:</h1>";
  str += "<h2>Anschrift:</h2>";
  str += "<p>" + checkInData.value.street + "</p>";
  str += "<p>" + checkInData.value.plz + ", " + checkInData.value.city + "</p>";
  str += "<p>" + checkInData.value.country + "</p>";
  str += "<h2>Gäste:</h2>";
  checkInData.value.guests.forEach((guest, id) => {
    str += "<h3>Gast " + id + " :</h3>";
    if (id === 0) {
      str += "<p>Nationalität: <b>" + guest.nationality + "</b></p>";
      str += "<p>Titel: <b>" + guest.title + "</b></p>";
    }
    str += "<p>Vorname: <b>" + guest.firstname + "</b></p>";
    str += "<p>Nachname: <b>" + guest.surname + "</b></p>";
    str += "<p>Geburtsdatum: <b>" + guest.birthday + "</b></p>";
  });

  return str;
}

function onSwiper(swiper: any) {
  mySwiper = swiper;
  mySwiper.disable();
}

function slideNext() {
  mySwiper.enable();
  mySwiper.slideNext();
  mySwiper.disable();
}

function slidePrev() {
  mySwiper.enable();
  mySwiper.slidePrev();
  mySwiper.disable();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Willkommen")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Settings' })))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(settings)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Swiper), { onSwiper: onSwiper }, {
            default: _withCtx(() => [
              _createVNode(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(slideNext, ["prevent"])
                  }, [
                    _createVNode(_unref(IonList), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItem), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Vorname")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonInput), {
                                      autocapitalize: "true",
                                      required: "",
                                      modelValue: checkInData.value.guests[0].firstname,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkInData.value.guests[0].firstname) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItem), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Nachname")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonInput), {
                                      autocapitalize: "true",
                                      required: "",
                                      modelValue: checkInData.value.guests[0].surname,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkInData.value.guests[0].surname) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItem), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Titel")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonInput), {
                                      autocapitalize: "true",
                                      modelValue: checkInData.value.guests[0].title,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkInData.value.guests[0].title) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItem), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Nationalität")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonInput), {
                                      autocapitalize: "true",
                                      type: "text",
                                      modelValue: checkInData.value.guests[0].nationality,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checkInData.value.guests[0].nationality) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItem), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Geburtsdatum")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonInput), {
                                      type: "date",
                                      modelValue: checkInData.value.guests[0].birthday,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checkInData.value.guests[0].birthday) = $event)),
                                      required: "",
                                      placeholder: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonCol))
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), { type: "submit" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Weiter")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 40, _hoisted_2)
                ]),
                _: 1
              }),
              _createVNode(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(slideNext, ["prevent"])
                  }, [
                    _hoisted_4,
                    _createVNode(_unref(IonList), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("PLZ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonInput), {
                              modelValue: checkInData.value.plz,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((checkInData.value.plz) = $event)),
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Stadt")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonInput), {
                              modelValue: checkInData.value.city,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((checkInData.value.city) = $event)),
                              autocapitalize: "true",
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Straße, Hausnummer")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonInput), {
                              modelValue: checkInData.value.street,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checkInData.value.street) = $event)),
                              autocapitalize: "true",
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Land")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonInput), {
                              modelValue: checkInData.value.country,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((checkInData.value.country) = $event)),
                              autocapitalize: "true",
                              required: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), { onClick: slidePrev }, {
                          default: _withCtx(() => [
                            _createTextVNode("Zurück")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), { type: "submit" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Weiter")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 40, _hoisted_3)
                ]),
                _: 1
              }),
              _createVNode(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(slideNext, ["prevent"])
                  }, [
                    (checkInData.value.guests.length > 1)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(checkInData.value.guests, (guest, number) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: guest }, [
                            (number > 0)
                              ? (_openBlock(), _createBlock(_unref(IonCard), { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCardHeader), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonCardTitle), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Gast " + _toDisplayString(number + 1), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(IonCardContent), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonList), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonItem), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonLabel), { position: "floating" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Vorname")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_unref(IonInput), {
                                                  modelValue: guest.firstname,
                                                  "onUpdate:modelValue": ($event: any) => ((guest.firstname) = $event),
                                                  autocapitalize: "true"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(IonItem), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonLabel), { position: "floating" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Nachname")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_unref(IonInput), {
                                                  modelValue: guest.surname,
                                                  "onUpdate:modelValue": ($event: any) => ((guest.surname) = $event),
                                                  autocapitalize: "true"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(IonItem), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonLabel), { position: "floating" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Geburtsdatum ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_unref(IonInput), {
                                                  type: "date",
                                                  modelValue: guest.birthday,
                                                  "onUpdate:modelValue": ($event: any) => ((guest.birthday) = $event),
                                                  required: "",
                                                  placeholder: ""
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(IonButton), {
                                      fill: "clear",
                                      size: "small",
                                      onClick: ($event: any) => (removeGuest(number))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Gast entfernen ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, "Keine Zusätzlichen Gäste")),
                    _createVNode(_unref(IonButtons), { class: "ion-padding" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonButton), { onClick: addGuest }, {
                          default: _withCtx(() => [
                            _createTextVNode("Gast hinzufügen")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), { onClick: slidePrev }, {
                      default: _withCtx(() => [
                        _createTextVNode("Zurück")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), { type: "submit" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Weiter")
                      ]),
                      _: 1
                    })
                  ], 40, _hoisted_5)
                ]),
                _: 1
              }),
              _createVNode(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createVNode(_unref(IonButton), {
                    fill: "clear",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (resetSignature()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Reset")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(VueSignaturePad), {
                    width: "100%",
                    height: "250px",
                    ref_key: "signaturePad",
                    ref: signaturePad,
                    options: {
              onEnd: onEnd,
              backgroundColor: 'rgb(232,232,232)',
            }
                  }, null, 8, ["options"]),
                  _createVNode(_unref(IonButton), { onClick: slidePrev }, {
                    default: _withCtx(() => [
                      _createTextVNode("Zurück")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    onClick: sendMail,
                    fill: "outline",
                    disabled: !signed.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bestätigen ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})